<template>
  <div class="modal-window uts018">
    <header class="modal-header">
      <div class="tit">{{$i18nUtil.trans("title.TodoLinkedListModal.001","관련 과제/보드")}}</div>
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <div class="info-txt">
        {{ $i18nUtil.trans("message.TodoLinkedListModal.001","연결하기 버튼을 통해 관련 과제/보드를 추가로 연결할 수 있습니다.") }}
      </div>
      <button type="button" class="btn_link_add" @click="addLink()">
        {{ $i18nUtil.trans("button.add","추가") }}
      </button>
      <div class="scroll">
        <ul>
          <li
            v-for="(link, linkIndex) in linkList"
            :value="link"
            :key="'linkIndex_' + linkIndex"
          >
            <div class="top">
              <span>{{ link.kbnName }}</span>
              <div v-if="link.paperId != ''" class="dividing_line_ty3"></div>
              <span v-if="link.paperId != ''">{{ link.categoryName }}</span>
            </div>
            <div v-if="link.paperId == ''" class="tit ell-singleline">{{ link.categoryName }}</div>
            <div v-else class="tit ell-singleline">{{ link.paperTitle }}</div>
            <button type="button" @click="removeLinkConfirm(link.targetId)">
              {{ $i18nUtil.trans("button.terminateConn","연결 해제") }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Datepicker from "vuejs-datepicker";
import EventBus from "@/js/eventbus/eventBus";

export default {
  components: {
    Datepicker
  },
  props: {
    modalInfo: {
      type: Object,
      required: true
    }
  },
  mounted() {
    console.log(this.linkList);
  },
  data() {
    return {
      date: new Date(this.$moment()),
      show: false,
      error: false,
      linkList: this.modalInfo.linkList
    };
  },
  methods: {
    ...mapActions("modals", ["showModal"]),
    addLink() {
      EventBus.$emit("main_TodoAddModal_linkedModalOpen", this.linkList);
      this.$emit("close");
    },
    removeLinkConfirm(param) {
      console.log(param);
      this.showConfirmDialog(
        { width: "400px" },
        this.$i18nUtil.trans("title.dialog.notice","알림"),
        this.$i18nUtil.trans("AB081"),
        this.$i18nUtil.trans("button.terminateConn","연결 해제"),
        this.removeLink,
        param,
        this.$i18nUtil.trans("button.dialog.cancel","취소")
      );
    },
    removeLink(param) {
      for (let index = 0; index < this.linkList.length; index++) {
        if (this.linkList[index].targetId === param.modalParam) {
          this.linkList.splice(index, 1);
        }
      }
      EventBus.$emit("main_TodoAddModal_removeLink", param.modalParam);
    }
  }
};
</script>
<style scoped>
.uts004 .scroll {
  overflow-y: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/main/modal/TodoLinkedListModal.vue